<div class="row" *ngIf="!showInvoice">
    <div class="col-md-9">
        <h5 class="num">{{'NumberOfAddedItems'|translate}} : {{this.items.length}}</h5>
    </div>
    <div class="col-md-3 divAddButton">
        <button class="Addbtn btn-icon-group" (click)="addItem()">
            <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
            {{'AddItem'|translate}}
        </button>
    </div>
</div>

<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="!showInvoice">
    <mat-card-content class="mat-mdc-card-content text-center">
        <form [formGroup]="form">
            <ng-container>
                <ng-container>
                    <div class="row text-right">

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="w-100 m-b-10">
                                <input type="text" placeholder="{{ 'SelectClient' | translate }}" aria-label="Assignee"
                                    matInput formControlName="clientId" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayClientFn.bind(this)">
                                    <mat-option *ngFor="let option of filteredClientsOptions" [value]="option.id">
                                        {{option.name}}
                                    </mat-option>
                                </mat-autocomplete>


                                @if(f['clientId'].touched && f['clientId'].invalid)
                                {
                                <mat-hint class="m-b-16 error-msg">
                                    @if(f['clientId'].errors && f['clientId'].errors['required'])
                                    {
                                    <div class="text-error"> {{ 'Chooseclient' | translate }}</div>
                                    }
                                </mat-hint>
                                }
                                <mat-label>{{ 'Clients' | translate }} </mat-label>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="text-right" *ngFor="let itemForm of GetItems; let i = index">
                        <div class="row" [formGroup]="itemForm">
                            <div class="col-md-4">
                                <mat-form-field appearance="outline" class="w-100 m-b-10">
                                    <input type="text" placeholder="{{ 'Items' | translate }}" aria-label="Assignee"
                                        matInput formControlName="productId" [matAutocomplete]="auto">
                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemsFn.bind(this)">
                                        <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.productId">
                                            {{option.fullName}}
                                        </mat-option>
                                    </mat-autocomplete>

                                    @if(itemForm.controls['productId'].touched &&
                                    itemForm.controls['productId'].invalid)
                                    {
                                    <mat-hint class="m-b-16 error-msg">
                                        @if(itemForm.controls['productId'].errors &&
                                        itemForm.controls['productId'].errors['required'])
                                        {
                                        <div class="text-error"> {{ 'ChooseProduct' | translate }}</div>
                                        }
                                    </mat-hint>
                                    }
                                    <mat-label>{{ 'Items' | translate }} </mat-label>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <mat-form-field appearance="outline" class="w-100 m-b-10">
                                    <mat-label>{{ 'Count' | translate }} </mat-label>
                                    <input matInput class="txt" type="number" onwheel="return false;"
                                        placeholder="{{ 'Count' | translate }} " formControlName="count" maxlength="3"
                                        minlength="1" />

                                    @if(itemForm.controls['count'].touched && itemForm.controls['count'].invalid)
                                    {
                                    <mat-hint class="m-b-16 error-msg">
                                        @if(itemForm.controls['count'].errors &&
                                        itemForm.controls['count'].errors!['required'])
                                        {
                                        <div class="text-error"> {{ 'EnterCount' | translate }}</div>
                                        }
                                    </mat-hint>
                                    }

                                </mat-form-field>
                            </div>
                            <div class="col-md-2" *ngIf="i!=0">
                                <i-tabler name="trash" class="icon-20 deleteIcon cursor-pointer"
                                    (click)="deleteItem(i)"></i-tabler>
                            </div>
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="row m-t-24">
                        <div class="col-sm-12">
                            <button mat-flat-button color="primary" class="orangSavebtn" (click)="submit()">
                                {{ 'Save' | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container></ng-container>
        </form>
    </mat-card-content>
</mat-card>

<app-invoice *ngIf="showInvoice" [BuySellOrderData]="DtoBuySellOrder"
    (showInvoice)="CloseInvoice($event)"></app-invoice>